export default __webpack_public_path__ + "static/media/gardening.b207503e.svg";